import styled from 'styled-components';

export const LoginContainer = styled.main`
    @media (max-width: 500px) {
        height: 100vh;
        width: 100%;
        display: flex;
        flex-direction: column;
        padding-top: 1.5rem;
    }
`;
export const RegContainer = styled.main`
    @media (max-width: 500px) {
        height: 100vh;
        /* position: fixed; */
        width: 100%;
        /* overflow: hidden; */
        display: flex;
        flex-direction: column;
    }
`;
export const LoginSection = styled.section`
    padding: 1rem;
    padding-bottom: 2rem;

    .title {
        text-align: center;
        margin-top: 1rem;
        margin-bottom: 2rem;
        h3 {
            font-style: normal;
            font-weight: 700;
            font-size: 26px;
            line-height: 31px;
            text-align: center;
            color: #000000;
            font-family: 'Neurial-Light', sans-serif;
            margin-bottom: 12px;
        }

        .title-copy {
            text-align: center;
            font-family: Outfit;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
        }
    }
    .login-note {
        color: rgba(0, 0, 0, 0.2);
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        a {
            color: #3875ea;
            text-decoration: none;
        }
    }
    @media (max-width: 500px) {
        width: 100%;
        height: 80%;
        // overflow-y: auto;
    }
`;

export const RegisterSection = styled.section`
    padding: 1rem;
    @media (min-width: 500px) {
        padding: 0;
        height: 100vh;
    }
    .title {
        text-align: center;
        margin-top: 2rem;
        h3 {
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;
            text-align: center;
            letter-spacing: -0.02em;
            color: #0a083b;
            font-family: 'Neurial-LightBold', sans-serif;
        }
        h6 {
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 26px;
            text-align: center;
            color: #0a083b;
        }
    }
    .login-note {
        color: rgba(0, 0, 0, 0.2);
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        padding-bottom: 2rem;
        a {
            color: #3875ea;
            text-decoration: none;
        }
    }
    .reg-form {
        display: flex;
        height: 100%;
        overflow: hidden;
        .reg-form-img {
            position: relative;
            background-color: #7fdbd440;
            padding: 4rem;
            width: 718px;
            .logo {
                height: 100%;
                max-height: 36px;
                margin-bottom: 1.5rem;
            }

            h1 {
                font-style: normal;
                font-weight: 700;
                font-size: 31px;
                line-height: 32px;
                color: #1b3b5f;
                text-align: center;
                width: 509px;
                font-family: 'Inter' !important;
                @media (min-width: 768px) and (max-width: 1023px) {
                    font-size: 21px;
                    width: 40vw;
                    line-height: 30px;
                }
            }
            .img-reg {
                position: absolute;
                /* top: 5rem; */
                left: -1rem;
                bottom: -5rem;
            }
            @media (min-width: 768px) and (max-width: 1023px) {
                padding: 2rem;
                width: 50vw;
            }
        }
        .form-sect {
            height: 100%;
            width: 50%;
            overflow: auto;
            @media (max-width: 767px) {
                width: 100%;
            }
        }
    }
`;

export const Forms = styled.form`
    margin: auto;
    padding: 1rem;
    padding-bottom: 3rem;
    width: 422px;
    margin-bottom: 2rem;
    background: #ffffff;
    /* box-shadow: 0px 4px 39px rgba(0, 0, 0, 0.05); */
    .form-group {
        width: 100%;
        border: 0.4px solid rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        padding: 5px 15px;
        height: 50px;
        overflow: hidden;
        position: relative;
        label {
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 12px;
            color: #57586e;
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
            a {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 17px;
                color: #0a083b;
                text-decoration: none;
            }
        }
        input {
            background: #ffffff;
            /* height: 55px; */
            font-size: 14px;
            width: 100%;
            padding: 0rem;
            height: 100%;
            outline: none;
            :focus {
                background-color: #ffffff;
            }

            ::placeholder {
                opacity: 0.2;
            }
            :-internal-autofill-selected {
                background-color: #ffffff !important;
            }
        }
        input[type='password'],
        input[type='tel'] {
            margin-bottom: 0;
        }
        input:-internal-autofill-selected {
        }
    }
    label {
        margin-bottom: 8px;
        display: block;
    }
    .error-message {
        color: red;
        font-size: 12px;
        margin-right: 1rem;
        padding-top: 0.5rem;
        margin-bottom: 0.5rem;
        text-align: right;
    }
    .forgot-link {
        text-align: right;
    }
    .forgot {
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 15px;
        color: #1b3b5f;
        text-align: right;
        width: 100%;
    }
    .border-group {
        border: 1px solid #f2f4f5;
        width: 384px;
        padding: 50px;
        border-radius: 8px;
    }
    .bottom-login {
        margin-top: 2px;
        p {
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            margin-bottom: 1rem;
            color: #090a0a;
            text-align: center;
            a {
                color: #1b3b5f;
                font-weight: 700;
            }
        }

        > button {
            padding: 15px 10px;
            height: 50px;
            width: 100%;
            background: #1b3b5f;
            border-radius: 48px;
            border: none;
            color: #ffffff;
            font-weight: 700;
            font-size: 14px;
            line-height: 20px;

            cursor: pointer;
            outline: none;
        }
        .desktop-socials {
            width: 100%;
            text-align: center;
            p {
                margin: 1rem auto;
                font-weight: 400;
                font-size: 13px;
                line-height: 24px;
                text-transform: uppercase;
                color: #979c9e;
            }
            div {
                display: flex;
                gap: 23px;
                justify-content: center;

                button {
                    width: 80px;
                    margin-bottom: 1rem;
                    padding: 15px 10px;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 0.3px solid rgba(0, 0, 0, 0.1);
                    border-radius: 5px;
                    background: unset;
                    cursor: pointer;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 19px;
                    text-align: center;

                    font-family: 'Neurial-light', sans-serif;
                    color: #0a083b;
                    :last-of-type {
                    }
                    margin-bottom: 0;
                }
            }
        }
    }
    .socials-auth {
        margin-top: 2rem;
        display: flex;
        width: 100%;
        gap: 25px;
        justify-content: center;
        button {
            border: 0.3px solid #0000004d;
            border-radius: 5px;
            width: 86px;
            height: 53px;
            background-color: #ffffff;
            display: flex;
            justify-content: center;
        }
    }

    @media (max-width: 500px) {
        margin: auto;
        padding: 0.5rem;
        padding-bottom: 3rem;
        width: 100%;
        box-shadow: none;
        height: 100%;
        display: flex;
        flex-direction: column;
        /* justify-content: space-between; */
        .form-group {
            width: 100%;

            label {
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 12px;
                font-style: normal;
                color: #72777a;
            }
            input {
                background: #ffffff;
                // height: 23px;
                font-size: 14px;
                width: 100%;
                padding: 0;
                color: #090a0a;
                margin-top: 0rem;
                ::placeholder {
                    color: #72777a;
                    opacity: 1;
                }
            }

            :-internal-autofill-selected {
                background-color: #ffffff !important;
            }
            select {
                background: #ffffff;
                border: 0.4px solid rgba(0, 0, 0, 0.1);
                border-radius: 10px;
                height: 53px;
                width: 100%;
                margin-top: 0.5rem;
                margin-bottom: 0.3rem;
                color: #0a083b;
                font-size: 14px;
                option {
                    padding-left: 2rem;
                }
                :focus {
                    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.1);
                    outline: none;
                }
                ::placeholder {
                    opacity: 0.2;
                }
            }
        }
        .error-message {
            color: red;
            font-size: 12px;
            margin-right: 0.8rem;
            padding-top: 0.3rem;
            margin-bottom: 1rem;
            text-align: right;
        }
        .forgot {
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 16px;
            color: #1b3b5f;
        }
        .border-group {
            border: none;
            width: auto;
            padding: 0;
            border-radius: 8px;
        }
        .bottom-login {
            margin-top: 10%;
            p {
                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
                margin-bottom: 1rem;
                color: #090a0a;
                a {
                    color: #1b3b5f;
                    font-weight: 700;
                }
            }
        }
        section {
            > button {
                padding: 15px 10px;
                height: 50px;
                left: 34px;
                top: 335px;
                width: 100%;
                background: #1b3b5f;
                border-radius: 48px;
                border: none;
                color: #ffffff;
                font-weight: 500;
                font-size: 16px;
                line-height: 16px;
                cursor: pointer;
            }
        }
        .socials-auth {
            margin-top: 2rem;
            display: flex;
            width: 100%;
            gap: 25px;
            justify-content: center;
            button {
                border: 0.3px solid #0000004d;
                border-radius: 5px;
                width: 86px;
                height: 53px;
                background-color: #ffffff;
            }
        }
    }
`;

export const RegForms = styled.form`
    margin: auto;
    padding: 1rem;
    padding-bottom: 3rem;
    width: ${(props) => (props.width ? props.width : '422px')};
    margin-bottom: 2rem;
    background: #ffffff;
    /* box-shadow: 0px 4px 39px rgba(0, 0, 0, 0.05); */
    .form-group {
        width: 100%;
        border: 0.4px solid rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        padding: 5px 15px;
        height: 50px;
        overflow: hidden;
        position: relative;
        label {
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 12px;
            color: #57586e;
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: center;
            a {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 17px;
                color: #0a083b;
                text-decoration: none;
            }
        }
        input {
            background: #ffffff;
            border: none;
            /* height: 55px; */
            font-size: 14px;
            width: 100%;
            padding: 0rem;
            outline: none;
            height: 100%;
            :focus {
                background-color: #ffffff;
            }

            ::placeholder {
                opacity: 0.2;
            }
            :-internal-autofill-selected {
                background-color: #ffffff !important;
            }
        }
        input[type='password'],
        input[type='tel'] {
            margin-bottom: 0;
            // margin-top: 0.5rem;
        }
        input:-internal-autofill-selected {
        }
    }
    hr {
        display: none;
    }

    .form-group-select {
        width: 100%;

        label {
            color: #979c9e;
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 24px;
        }
        select {
            background: #ffffff;
            border: 0.4px solid rgba(0, 0, 0, 0.1);
            border-radius: 10px;
            height: 53px;
            width: 100%;
            margin-top: 0.5rem;
            margin-bottom: 0.3rem;
            color: #72777a;
            font-size: 14px;
            padding-left: 1rem;
            padding-right: 1rem;

            option {
                padding-left: 2rem;
            }
            :focus {
                box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.1);
                outline: none;
            }
            ::placeholder {
                opacity: 0.2;
            }
        }
    }
    .border-group {
        border: 1px solid #f2f4f5;
        width: 384px;
        padding: 50px;
        border-radius: 8px;
    }
    .error-message {
        color: red;
        font-size: 12px;
        margin-right: 0.8rem;
        padding-top: 0.3rem;
        margin-bottom: 0.6rem;
        text-align: right;
    }
    > button {
        padding: 15px 10px;
        height: 48px;
        width: 100%;
        background: #1b3b5f;
        border-radius: 48px;
        border: none;
        color: #ffffff;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        cursor: pointer;
        outline: none;
    }
    .desktp-socials {
        width: 100%;
        text-align: center;
        p {
            margin: 1rem auto;
            font-weight: 400;
            font-size: 13px;
            line-height: 24px;
            text-transform: uppercase;
            color: #979c9e;
        }
        div {
            display: flex;
            gap: 23px;
            justify-content: center;

            button {
                width: 80px;
                margin-bottom: 1rem;
                padding: 15px 10px;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: 0.3px solid rgba(0, 0, 0, 0.1);
                border-radius: 5px;
                background: unset;
                cursor: pointer;
                font-weight: 400;
                font-size: 16px;
                line-height: 19px;
                text-align: center;

                font-family: 'Neurial-light', sans-serif;
                color: #0a083b;
                :last-of-type {
                }
                margin-bottom: 0;
            }
        }
    }
    .desktop-socials {
        width: 100%;
        text-align: center;
        p {
            margin: 1rem auto;
            font-weight: 400;
            font-size: 13px;
            line-height: 19px;
            color: #0a083b;
        }
        button {
            width: 100%;
            margin-bottom: 1rem;
            padding: 15px 30px 15px 10px;
            height: 50px;
            border: 0.3px solid rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            background: unset;
            cursor: pointer;
            font-weight: 400;
            font-size: 14px;
            line-height: 16px;
            display: flex;
            text-align: center;
            font-family: 'Neurial-light', sans-serif;
            color: #72777a;
            justify-content: space-between;
            :last-of-type {
                margin-bottom: 0;
            }
        }
    }
    .sign-in-button {
        padding: 15px 10px;
        height: 48px;
        width: 100%;
        background: #1b3b5f;
        border-radius: 48px;
        border: none;
        color: #ffffff;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        cursor: pointer;
    }
    .sign-in-button:disabled {
        background: #1b3b5f;
        opacity: 0.5;
        cursor: not-allowed;
    }
    .socials-auth {
        margin-top: 2rem;
        display: flex;
        width: 100%;
        gap: 25px;
        justify-content: center;
        button {
            border: 0.3px solid #0000004d;
            border-radius: 5px;
            width: 86px;
            height: 53px;
            background-color: #ffffff;
        }
    }

    @media (max-width: 500px) {
        margin: auto;
        padding: 0.5rem;
        width: 100%;
        box-shadow: none;
        margin-bottom: 0;
        .border-group {
            border: none;
            width: auto;
            padding: 0;
            border-radius: 8px;
        }
        .form-group-select {
            width: 100%;
            label {
                color: #979c9e;
                font-style: normal;
                font-weight: 400;
                font-size: 15px;
                line-height: 24px;
            }
            select {
                background: #ffffff;
                border: 0.4px solid rgba(0, 0, 0, 0.1);
                border-radius: 10px;
                height: 53px;
                width: 100%;
                margin-top: 0.5rem;
                margin-bottom: 0.3rem;
                color: #72777a;
                font-size: 16px;
                padding-left: 1rem;
                padding-right: 1rem;

                option {
                    padding-left: 2rem;
                }
                :focus {
                    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.1);
                    outline: none;
                }
                ::placeholder {
                    opacity: 0.2;
                }
            }
        }
        hr {
            width: 50%;
            margin: 1rem auto !important;
            margin-top: 1rem !important;
            border-top: 1px solid #e3e5e6;
        }
        .form-group {
            width: 100%;
            label {
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 12px;
                font-style: normal;
                color: #72777a;
            }
            input {
                background: #ffffff;
                // height: 23px;
                font-size: 14px;
                width: 100%;
                padding: 0;
                color: #090a0a;
                margin-top: 0rem;
                ::placeholder {
                    color: #72777a;
                    opacity: 1;
                }
            }
        }
        .error-message {
            color: red;
            font-size: 12px;
            margin-right: 0.8rem;
            padding-top: 0.3rem;
            margin-bottom: 0.6rem;
            text-align: right;
        }
        .sign-in-button {
            padding: 15px 10px;
            height: 50px;
            width: 100%;
            background: #1b3b5f;
            border-radius: 48px;
            border: none;
            color: #ffffff;
            font-weight: 500;
            font-size: 16px;
            line-height: 16px;
            cursor: pointer;
        }
        .socials-auth {
            margin-top: 2rem;
            display: flex;
            width: 100%;
            gap: 25px;
            justify-content: center;
            button {
                border: 0.3px solid #0000004d;
                border-radius: 5px;
                width: 86px;
                height: 53px;
                background-color: #ffffff;
            }
        }
    }
`;
